// Theme registry — ported from discover's src/theme/tokens.ts (antd bridge
// dropped: discover-chat uses no Ant Design). Adding a theme = one entry here
// plus one [data-theme] block in theme.css.

export const DARK_THEME_IDS = ['dark', 'midnight', 'ocean', 'ember'];

export const THEMES = [
  { id: 'light', label: 'Light', swatch: ['#ffffff', '#3b6cff'] },
  { id: 'dark', label: 'Dark', swatch: ['#22252b', '#6f8dff'] },
  { id: 'midnight', label: 'Midnight', swatch: ['#0a0d16', '#7c6bff'] },
  { id: 'solar', label: 'Solar', swatch: ['#faf7f2', '#d96f32'] },
  { id: 'forest', label: 'Forest', swatch: ['#ffffff', '#16a34a'] },
  { id: 'ocean', label: 'Ocean', swatch: ['#0d1b2a', '#38bdf8'] },
  { id: 'sakura', label: 'Sakura', swatch: ['#faf6f8', '#ec4899'] },
  { id: 'ember', label: 'Ember', swatch: ['#1c1917', '#fb923c'] },
];

// Ink for a theme *preview* (the cards in Settings). An entry carries only
// [surface, accent] and no foreground value, so a preview's text bars need
// their tone derived from whether the previewed theme is a dark one — it
// describes that card's own contents, not the theme currently applied. Lives
// here beside the swatches because this module is where literal colour values
// belong; a JSX file reads it as data.
export const previewInk = (id) =>
  DARK_THEME_IDS.includes(id)
    ? { bar: 'rgba(255, 255, 255, 0.30)', edge: 'rgba(255, 255, 255, 0.16)' }
    : { bar: 'rgba(15, 23, 42, 0.20)', edge: 'rgba(15, 23, 42, 0.10)' };

export const THEME_IDS = THEMES.map((t) => t.id);
export const DEFAULT_THEME = 'midnight';
export const STORAGE_KEY = 'theme';
